import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { FormEnums } from "models/enums";
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { IntegrationFormTypes } from "models/formTypes";
import { VismaAdvisorFormProps } from "models/propTypes/integrationsPropTypes";
//#endregion
//#region components
import { GenericForm } from "components/common";
import { Grid } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const descriptionKey = (status?: string) => {
  switch (status) {
    case "PendingConfirmation":
      return TranslationKeys.Integrations.VismaAdvisorConfirmDescription;
    case "NeedsReauthorization":
      return TranslationKeys.Integrations.VismaAdvisorReauthorizeDescription;
    case "Active":
      return TranslationKeys.Integrations.VismaAdvisorConnectedDescription;
    case "Paused":
      return TranslationKeys.Integrations.VismaAdvisorPausedDescription;
    default:
      return TranslationKeys.Integrations.VismaAdvisorLoginDescription;
  }
};

const VismaAdvisorForm: ForwardRefRenderFunction<FormHandles, VismaAdvisorFormProps> = (props, ref) => {
  const isPending = props.vismaAdvisorStatus === "PendingConfirmation";
  const isConnected = props.vismaAdvisorStatus === "Active" || props.vismaAdvisorStatus === "Paused";

  return (
    <GenericForm<IntegrationFormTypes.VismaAdvisorConnect>
      formRef={ref}
      {...props}
      // Pending: saving confirms (toggle on) or discards (toggle off). Otherwise saving only logs in.
      disableSubmitOn={(values) => isConnected || (!isPending && !values.vismaAdvisorAction)}
      fields={{
        vismaAdvisorAction: {
          label: isPending
            ? TranslationKeys.Integrations.VismaAdvisorIsRightAgency
            : TranslationKeys.Integrations.VismaAdvisorLogin,
          type: FormEnums.FormFieldType.TOGGLE,
          disabled: isConnected,
          classes: { formControl: cssExports.inlineLabel },
        },
        vismaAdvisorDescription: {
          label: "",
          type: FormEnums.FormFieldType.CUSTOM,
          customField: (
            <Grid container className={cssExports.formControlDescription} id="visma-advisor-description">
              {LocalizationHelperInstance.getFormattedMessage(descriptionKey(props.vismaAdvisorStatus), undefined, {
                agency: props.vismaAdvisorAgencyName ?? "",
              })}
            </Grid>
          ),
        },
      }}
    />
  );
};

export default forwardRef(VismaAdvisorForm);
